import { Component, OnInit } from '@angular/core';
import { Company } from '../../../dto/company';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { environment } from '../../../../environments/environment';
import { CompanyService } from '../../services/company.service';
import { RoleService } from '../../../services/role.service';
import { EventLog } from '../../../dto/event-log';
import { EventLogService } from '../../../services/crud/event-log.service';
import { ObjectComment } from '../../../dto/object-comment';
import { ObjectCommentsService } from '../../services/object-comment.service';
import {PartnerApiKey} from '../../../dto/partner-api-key';
import {ContentRowField} from '../../../shared/content-row/content-row.component';

@Component({
  selector: 'app-company-view',
  templateUrl: './company-view.component.html',
  styleUrls: ['./company-view.component.css']
})
export class CompanyViewComponent implements OnInit {
  company: Company;
  logs: EventLog[];
  comments: ObjectComment[];
  commentsTarget = 2;

  fields = [
    { header: 'Name', cell: (row: Company) => `${row.name}` } as ContentRowField<Company>,
    { header: 'Brand Name', cell: (row: Company) => `${row.brandName || ''}` },
    { header: 'Director name', cell: (row: Company) => `${row.directorFirstName || ''} ${row.directorName || ''}` },
    { header: 'Director job title DE', cell: (row: Company) => `${row.directorJobTitle || ''}` },

    { header: 'Director job title EN', cell: (row: Company) => `${row.directorJobTitleEn || ''}` },

    { header: 'Customer Number', cell: (row: Company) => `${row.customerNumber || '(empty)'}`},
    { header: 'FX Rate Margin Percent', cell: (row: Company) => `${row.fxRateMargin || '(empty)'}`},

    { header: 'Phone', cell: (row: Company) => `${row.phone || ''}` },
    { header: 'Email', cell: (row: Company) => `${row.email || ''}` },
    { header: 'Website URL', isExternalLink: (row: Company) => true, link: (row: Company) => `${row?.websiteUrl || ''}`, cell: (row: Company) => `${row?.websiteUrl || ''}` },
    { header: 'Support Email', cell: (row: Company) => `${row.supportEmail || ''}` },
    { header: 'Support Phone', cell: (row: Company) => `${row.supportPhone || ''}` },
    { header: 'Country', cell: (row: Company) => `${row.countryName || ''}` },
    { header: 'City', cell: (row: Company) => `${row.city || ''}` },
    { header: 'Address', cell: (row: Company) => `${row.address || ''}` },
    { header: 'Postcode', cell: (row: Company) => `${row.postcode || ''}` },
    { header: 'VAT reg nr', cell: (row: Company) => `${row.vatRegNr || ''}` },
    { header: 'VAT rate', cell: (row: Company) => `${row.vatRate || ''}` },
    { header: 'Order Method', cell: (row: Company) => {
        if( row.orderMethod == 0 ) {
return 'Disabled';
} else if (row.orderMethod == 1) {
return 'Web and Apps';
} else if (row.orderMethod == 2) {
return 'App only';
} else {
return '(invalid)';
}

      } },
    { header: 'Order language for customer orders', type: 'number', cell: (row: Company) => {
        if( row.orderLanguage == 0 ) {
          return 'german';
        } else {
          return 'english';
        }

      } },
    { header: 'Order URL', cell: (row: Company) => `${this.getOrder(row.orderUrl) || ''}`, isExternalLink: (row: Company) => true, link: (row: Company) => this.getOrder(row.orderUrl) || false },
    { header: 'Brand Referral URL', cell: row => row.brandReferralCode != null ? `${this.getBrandReferral(row.brandReferralCode) || ''}` : "", isExternalLink: (row: Company) => true, link: row => row.brandReferralCode != null ? this.getBrandReferral(row.brandReferralCode) || false : false },
    { header: 'Google Analytics Code', cell: (row: Company) => `${row.googleAnalyticsCode || ''}` },
    { header: 'Facebook Pixel ID', cell: (row: Company) => `${row.facebookPixelId || ''}` },
    { header: 'Active', type: 'boolean', cell: (row: Company) => `${row.active.toString()}` },
    { header: 'Bank Name', cell: (row: Company) => `${row.bankName || ''}` },
    { header: 'Bank Sort Code', cell: (row: Company) => `${row.bankSortCode || ''}` },
    { header: 'Bank Branch No', cell: (row: Company) => `${row.bankBranchNo || ''}` },
    { header: 'Account No', cell: (row: Company) => `${row.accountNo || ''}` },
    { header: 'IBAN', cell: (row: Company) => `${row.iban || ''}` },
    { header: 'BIC', cell: (row: Company) => `${row.bic || ''}` },
    { header: 'SWIFT', cell: (row: Company) => `${row.swift || ''}` },
    { header: 'Voucher Payment Enabled', type: 'boolean', cell: (row: Company) => `${row.voucherPaymentEnabled}` },
    { header: 'Invoice Payment Enabled', type: 'boolean', cell: (row: Company) => `${row.invoicePaymentEnabled}` },
    { header: 'Sofort Payment Enabled', type: 'boolean', cell: (row: Company) => `${row.sofortPaymentEnabled}` },
    { header: 'Cash on delivery Payment Enabled', type: 'boolean', cell: (row: Company) => `${row.cashOnDeliveryPaymentEnabled}` },
    { header: 'Credit card Payment Enabled', type: 'boolean', cell: (row: Company) => `${row.creditCardPaymentEnabled}` },
    { header: 'WebID for Bulk Orders Enabled', type: 'boolean', cell: (row: Company) => `${row.webIdForBulkOrdersEnabled}` },

    // MS
    { header: 'Direct Invoicing', type: 'boolean', cell: (row: Company) => `${row.directInvoicingEnabled}` },
    { header: 'Short code', cell: (row: Company) => `${row.partnerShortCode}` },

    { header: 'Card Processor Enquiry Enabled', type: 'boolean', cell: (row: Company) => `${row.cardProcessorEnquiryEnabled}` },
    { header: 'Partner Wallet Enabled', type: 'boolean', cell: (row: Company) => `${row.partnerWalletEnabled}` },

    { header: 'Parnter Wallet Default Top-Up Fee', cell: (row: Company) => `${row.partnerWalletDefaultLoadFee || '(none)'}`},

    { header: 'Multi-Wallets Enabled', type: 'boolean', cell: (row: Company) => `${row.canCreateWallets}` },

    { header: 'Facebook URL', cell: (row: Company) => `${row.facebookUrl || '(empty)'}`, isExternalLink: (row: Company) => true, link: (row: Company) => row.facebookUrl || false},
    { header: 'Instagram URL', cell: (row: Company) => `${row.instagramUrl || '(empty)'}`, isExternalLink: (row: Company) => true, link: (row: Company) => row.instagramUrl || false },
    { header: 'TikTok URL', cell: (row: Company) => `${row.tikTokUrl || '(empty)'}`, isExternalLink: (row: Company) => true, link: (row: Company) => row.tikTokUrl || false },
    { header: 'YouTube URL', cell: (row: Company) => `${row.youTubeUrl || '(empty)'}`, isExternalLink: (row: Company) => true, link: (row: Company) => row.youTubeUrl || false },

  ] as ContentRowField<Company>[];

  constructor(
    private router: Router,
    private location: Location,
    private route: ActivatedRoute,
    private companyService: CompanyService,
    private roleService: RoleService,
    private logService: EventLogService,
    private objectCommentsService: ObjectCommentsService,
  ) { }

  ngOnInit() {
    const id = parseInt(this.route.snapshot.paramMap.get('id'));
    this.companyService.get(id).subscribe(company => {
      company.logoUrl = company.logoFileName ? environment.apiUrl + company.logoFileName : null;
      this.company = company;
    });

    this.logService.get(18, id).subscribe(data => {
      this.logs = data;
    });
    this.objectCommentsService.getForObject(id, this.commentsTarget).subscribe(data => {
      this.comments = data;
    });

  }

  returnBack() {
    this.location.back();
  }

  editEnabled() {
    return this.roleService.hasRoles(['admin', 'partner']);
  }

  showLogs() {
    return this.roleService.hasRoles(['admin', 'manager', 'agent', 'compliance']);
  }

  getOrder(orderUrl: string): string {
    return location.origin + '/order/' + orderUrl;
  }

  getBrandReferral(brandReferralUrl: string): string {
    return location.origin + '/brand/' + brandReferralUrl;
  }

}
